import { type ComponentChildren } from 'preact'
import Link from '~/components/Link'

import paths from '~/enums/paths'
import type { EntryMeta } from '~/types'
import MainPage from './MainPageTemplate'

interface ProjectTemplateProps {
	meta: EntryMeta
	backTo?: string
	children: ComponentChildren
}

// Full-page content wrapper for an entry (used by the experiments route). Renders a
// back-link plus the entry header, then falls the entry body through as children.
export default function ProjectTemplate({ meta, backTo, children }: ProjectTemplateProps) {
	return (
		<MainPage menus={[null, null, 'default', null]}>
			<div className="h-full overflow-y-auto px-3 py-2 backdrop-blur-sm">
				<Link href={backTo} className="text-primary-light no-underline hover:underline">
					← back
				</Link>
				<header className="mt-4 mb-6">
					<h1 className="font-bold text-3xl m-0">{meta.name}</h1>
					<p className="mt-1 text-white/70">{meta.excerpt}</p>
				</header>
				<div className="leading-relaxed">{children}</div>
			</div>
		</MainPage>
	)
}

ProjectTemplate.defaultProps = {
	backTo: paths.sandbox,
}
